import { ReportDataSets } from './report-data-sets.model';

export class ReportData {
    dataSets:ReportDataSets[];
    xAxis:string[];
    gridInformation:any;
}